import { type ReactNode } from 'react';
import { FolderOpenIcon } from '@phosphor-icons/react/dist/csr/FolderOpen';
import { useTranslation } from 'react-i18next';

import { ListState } from './ListState';

/**
 * Empty — the list has never had anything in it.
 *
 * Distinct from no-results, and the distinction is the whole reason both exist:
 * "Nothing matches your filters" offers Clear filters, "there is nothing here"
 * offers the thing that creates one. Showing the wrong one sends an agent
 * hunting for a filter that was never applied.
 *
 * The default copy is deliberately GENERIC. The handoff's example ("No cases
 * yet") belongs to one of the six lists this table serves; a default that names
 * cases would ship "No cases yet" above the Users list. Callers pass their own.
 */

export interface EmptyStateCopy {
  title?: string;
  body?: string;
}

export function EmptyState({ title, body, action }: EmptyStateCopy & { action?: ReactNode }) {
  const { t } = useTranslation();

  return (
    <ListState
      icon={<FolderOpenIcon size={26} weight="regular" />}
      title={title ?? t('list.emptyTitle')}
      body={<p>{body ?? t('list.emptyBody')}</p>}
      {...(action === undefined ? {} : { action })}
    />
  );
}
